import { Box, Button, Dialog, DialogActions, DialogContent, Tooltip, useMediaQuery } from "@mui/material";
import makeStyles from '@mui/styles/makeStyles';
import { FC, useCallback, useEffect, useState } from "react";
import { LocalStorage } from "src/framework/commons/LocalStorage";
import theme from "src/theme/light";
import styled from "styled-components";
import { distribuidores$, getDistribuidores } from "src/store/global.store";
import { useObservable } from "src/framework/store/storeUtil";
import { TrocarDistribuidor } from "src/providers/cadastros/TrocaDistribuidor";
import { Conta, TIPO_CONTA_VAREJO } from "src/types";
import { DEFAULT_VERTICAIS } from "src/components/vendas/types";
import { ListUtil } from "src/framework/commons/ListUtil";
import { cnpj, cpf } from "src/framework/commons/masks";
import "../styles.css";
import { notifierStore } from "src/framework/store/NotifierStore";
import { InputText } from "src/framework/components/forms/inputs/InputText";
import { InputComboBoxList } from "src/framework/components/forms/inputs/InputComboBoxList";


const InfoBoxTitle = styled.h4({
})

interface InfoBoxItemProperties {
    direction: "column" | "row"
}

const InfoBoxItem = styled.div<InfoBoxItemProperties>((props) => ({
    display: "flex",
    flexDirection: props.direction,
    height: props.direction === "row" ? "18px" : "inherit"
}))

const InfoBoxContainer = styled.div({
    display: "flex",
    flexDirection: "column"
})

const text = theme.palette.grey;

interface ModalSolicitacaoTrocarDistribuidor {
    openDialog: boolean;
    handleClose: () => void;
    onConfirm: () => void;
    conta_id?: number;
	segmento?: string;
	revenda?: string;
	distribuidor_atual?: string;
	cnpj_distribuidor_atual?: string;
	distribuidor_novo?: string;
	cnpj_distribuidor_novo?: string;
	justificativa?: string;
	executivo_vendas?: string;
	solicitante?: string;
	data_solicitacao?: string;
	situacao?: string;
	devolutiva?:  string;
	user_guilted_id?: string;
}

const solicitacaoTrocarDistribuidor = new TrocarDistribuidor()

const getListaDistribuidores = (options: any[], searchText: string) => {
    const search = (searchText || '').replace(/[^a-zA-Z0-9]/g, '')
    if (search.length !== 11 && search.length !== 14) return []
    return options.filter((item: { cnpj_cpf: string }) => {
        return item.cnpj_cpf === search
    })
}

const useStyles = makeStyles({
    root: {
        padding: "8px 16px",
    }
})

const ModalCriarSoliciatacao: FC<ModalSolicitacaoTrocarDistribuidor> = ({
    openDialog, 
    handleClose,
    onConfirm,
}) => {
    const classes = useStyles()

    const isMobile = useMediaQuery(theme.breakpoints.down('md'));

    const userInfo = LocalStorage.get("solar.userExtraInfo", true)

    const [distribuidoresSearch, setDistribuidoresSearch] = useState<string>('')
    const [justificativa, setJustificativa] = useState("");
    const [errorJustificativa,setErrorJustificativa] = useState(false)
    const [errorCpfCnpj,setErrorCpfCnpj] = useState(false)
    const [distribuidorState, setDistribuidorState] = useState<Conta | null>(null);
    const [errorState, setErrorState] = useState<string[]>([]);
    const [formState, setFormState] = useState<any>(DEFAULT_VERTICAIS);
    const [tooltipError, setTooltipError] = useState("")

    const distribuidores = useObservable(distribuidores$)

    const FooterBottom = isMobile ? Box : DialogActions;

    useEffect(() => {
        getDistribuidores()
    }, [])

    useEffect(()=>{
        if (distribuidorState){
            setErrorCpfCnpj(false);
        } 
    }, [distribuidorState])

    useEffect(()=>{
        if (justificativa && justificativa?.length >= 10){
            setErrorJustificativa(false);
            setTooltipError("");
        }

        if (justificativa && justificativa?.length < 10){
            setErrorJustificativa(true);
        }
    }, [justificativa])

    function validateFields() {
        const valid = (!justificativa || justificativa?.length < 10) || !distribuidorState
        return valid
    }

    const handleEdit = async () => {
        const validateNullFields = validateFields()
        if (!justificativa || justificativa?.length < 10) {
            setErrorJustificativa(true);
        }
        if (!distribuidorState){
            setErrorCpfCnpj(true);
        }
        if (!distribuidorState || !justificativa){
            setTooltipError("Para confirmar a solicitação, é necessário que os campos de preenchimento obrigatório sejam preenchidos.")
        }
        if (validateNullFields === false){
            const data = {
                "segmento": "on",
                "distribuidor_novo": distribuidorState?.nome,
                "cnpj_distribuidor_novo": distribuidorState?.cnpj_cpf,
                "justificativa": justificativa,
                "solicitante": userInfo?.name,
                "conta_id": userInfo?.revenda_cnpj_cpf,
            }

           await solicitacaoTrocarDistribuidor.criarSolicitacao(data).then(
                (res) => {
                    handleClose();
                    onConfirm();
                    if (!!res) {
                        notifierStore.setNotifier({
                            content: res.message.length ? res.message : ["Solicitação de troca enviada com sucesso."],
                            title: "Aviso",
                            timeOut: 2500,
                            onFinishTimeout: () => notifierStore.setOpen(false),
                            onClose: () => notifierStore.setOpen(false)
                        });
                        notifierStore.setOpen(true);
                    }
                }
           );
        }        
    };

    const formataCpfCnpj = useCallback((cpfCnpj: string)=>{
        const normalizedCpfCnpj = cpfCnpj?.replace(/[^a-zA-Z0-9]/g,'') || ''
        if (!normalizedCpfCnpj) return ''
        if (normalizedCpfCnpj.length === 11) return cpf({ target: { value: normalizedCpfCnpj } })?.target?.value
        if (normalizedCpfCnpj.length === 14) return cnpj({ target: { value: normalizedCpfCnpj } })?.target?.value
        return cpfCnpj
    },[])

    return (
        <Dialog
            className={"modal-edit-distribuidor"}
            open={openDialog}
            onClose={handleClose}
            aria-labelledby="form-dialog-title"
        >
            <div style={{ paddingLeft: "16px",  borderBottom: `1px solid ${text[400]}` }}>
            <span>
                <h2>Alterar distribuidor</h2>
            </span>
            </div>
            <div className="X12 edit-distribuidor-subtilte" style={{ textAlign: "center", color: "#717171" }}>
                <span>
                    Preencha as informações referente ao novo distribuidor escolhido.
                </span>
            </div>
            <DialogContent style={{ height: isMobile ? "600px" : "550px" }} classes={{ root: isMobile ? classes.root : undefined }}>
                <div className="X12 M12">
                    <InputText
                        label={"CNPJ/CPF da revenda"}
                        fullWidth={true}
                        mask={"cpf_cnpj"}
                        value={formataCpfCnpj(userInfo.revenda_cnpj_cpf)}
                        name={"cnpj"}
                        disabled
                        />
                </div>
                <div className="X12 M12">
                    <InputText
                        label={"CNPJ distribuidor atual"}
                        fullWidth={true}
                        mask={"cpf_cnpj"}
                        value={formataCpfCnpj(userInfo?.distribuidor_cnpj_cpf)}
                        name={"cnpj"}
                        disabled
                    />
                </div>
                <div className="X12 M12">
                    <InputComboBoxList
                            id={`solicitacao-troca-distribuidor-cb-${userInfo?.revenda_id}`}
                            key={`solicitacao-troca-distribuidor-cb-${userInfo?.revenda_id}`}
                            label={"* Distribuidor"}
                            filterOptions={(opts, state) => getListaDistribuidores(opts, state.inputValue)}
                            value={distribuidorState}
                            textField="nome"
                            valueField="id"
                            error={errorCpfCnpj}
                            noOptionsText={distribuidoresSearch ? "Não existem registros" : "Digite o CNPJ do distribuidor"}
                            searchValue={distribuidoresSearch}
                            renderOptions={(option: Conta) => {
                                return `${option.nome}`;
                            } }
                            renderOptionsLabel={(option: Conta) => {
                                return `${option.nome}`;
                            } }
                            onInputChange={e => {
                                setDistribuidorState(null);
                                const text = (e.target.value || '').replace(/[^a-zA-Z0-9]/g, '')?.toUpperCase();
                                if (text.length > 14) {
                                    e.stopPropagation();
                                    return;
                                }
                                setDistribuidoresSearch(text)
                            }}
                            onChange={(value: Conta) => {
                                setDistribuidoresSearch('')
                                const state: any = formState;
                                if (value === null) {
                                    state.distribuidor = null;
                                    state.distribuidor_id = null;
                                    setDistribuidorState(null);
                                } else {
                                    state.distribuidor = value;
                                    state.distribuidor_id = value.id;
                                    setDistribuidorState({ ...value });
                                }
                                setFormState({ ...state });
                                const _errorState = ListUtil.removeItem(errorState, "distribuidor_id");
                                setErrorState([..._errorState]);
                            } }
                            options={distribuidores?.data?.filter((d: any) => d.tipo_conta_id !== TIPO_CONTA_VAREJO) || []}  
                    />
                </div>
                <div className="X12">
                    <InputText
                        label={"* Justificativa"}
                        disabled={false}
                        fullWidth={true}
                        multiline
                        maxRows={7}
                        minRows={7}
                        InputProps={{
                        rows: 5
                        }}
                        error= {errorJustificativa}
                        value={justificativa}
                        name={"justificativa"}
                        
                        onChange={(e: any) => {
                            setJustificativa(e.target.value);
                        }}
                        helperText={"Mínimo 10 caracteres"}
                    />
                </div>
                <InfoBoxContainer>
                    <InfoBoxItem direction="row">
                        <p className="box-info-edit-distribuidor">
                            <InfoBoxTitle>Informações importantes</InfoBoxTitle>
                            <li>
                            Ao clicar em confirmar, será enviado um e-mail para a equipe responsável e a sua solicitação será analisada.                     
                            </li>
                            <li>
                            Importante: caso a sua solicitação seja aprovada, você só poderá solicitar a troca de distribuidor novamente após 90 dias.
                            </li>
                        </p>
                    </InfoBoxItem>
                </InfoBoxContainer>
            </DialogContent>
            <FooterBottom className="footer-edit-distribuidor" style={isMobile ? { display: "flex", flexDirection: "column-reverse", width: "100%" } : {}}>
                <Button onClick={handleClose} color="secondary" fullWidth={isMobile} variant={isMobile ? "outlined" : "text"}>
                    Cancelar
                </Button>
                <Tooltip
                    title={tooltipError}
                    placement="top"
                >
                    <Button
                        style={isMobile ? { width: "100%", marginBottom: "8px" } : {}}
                        color="primary"
                        variant="contained"
                        disableElevation
                        onClick={handleEdit}
                        fullWidth={isMobile}
                    >
                        Salvar
                    </Button>
                </Tooltip>
            </FooterBottom>
        </Dialog>
    );
}

export { ModalCriarSoliciatacao }